export default "__VITE_ASSET__CGh1fn_6__"